import { NgClass } from '@angular/common';
import { Component, input, OnInit, output } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { TranslatePipe } from '@ngx-translate/core';
import { SchoolService } from '../../../../app/main/service';
import { CurrencyType } from '../../../../app/main/shared/enum/currencyType.enum';
import { MoneyPipe } from '../../pipes/currency-format/currency-format.pipe';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'ms-stat',
    templateUrl: './stat.component.html',
    styleUrls: ['./stat.component.scss'],
    imports: [
        MatCardModule,
        NgClass,
        FontAwesomeModule,
        FlexLayoutModule,
        MatFormFieldModule,
        MoneyPipe,
        TranslatePipe,
        MatButtonModule,
    ],
})
export class StatComponent implements OnInit {
    bgClass = input<string>(null);
    icon = input<string>(null);
    count = input<number>(null);
    label = input<string>(null);
    url = input<string>(null);
    content = input<string>(null);
    data = input<number>(null);
    format = input<boolean>(null);
    refreshing = input<boolean>(false);
    hideHeader = input<boolean>(false);
    hideActions = input<boolean>(false);
    readonly onRefresh = output({ alias: 'onRefresh' });
    readonly onGoToDetails = output({ alias: 'onGoToDetails' });
    currencyType: CurrencyType;
    constructor(private schoolService: SchoolService) {}

    ngOnInit() {
        this.currencyType = this.schoolService.getActiveSchool()
            ? this.schoolService.getActiveSchool().currency
            : CurrencyType.KZT;
    }

    goToDetails() {
        this.onGoToDetails.emit();
    }

    refresh() {
        this.onRefresh.emit();
    }
}
